import React from 'react';

const ErrorBubble = ({message, children}) => {
    return (
        <div
            className="error-bubble"
            style={{
                padding: '1rem',
                marginTop: '1rem',
                borderRadius: '0.5rem',
                background: 'rgb(255, 255, 255)',
                color: '#ec1e1e',
                fontWeight: 600,
                fontSize: '1.1rem',
                marginBottom: '1.5rem',
                border: '1px dashed red',
                height: 'max-content'
            }}
            key={message}
        >
            {message}
            {children}
        </div>
    );
};

export default ErrorBubble;



// WEBPACK FOOTER //
// ./components/error_bubble.js